import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { CTAButton, SHOPIFY_URL } from './ui/CTAButton';
export function HeroSection() {
  return <section className="pt-20 pb-16 px-4 bg-white overflow-hidden" data-id="element-106">
      <div className="max-w-4xl mx-auto text-center" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm md:text-base font-bold mb-6 border border-blue-200 text-[#002AA6] bg-[#62FB5A]" data-id="element-108">
          🌱 Para personas veganas y para quienes quieren empezar a comer más
          vegetal
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight" data-id="element-109">
          MegaPack Dietas para Veganos
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.15
      }} className="text-xl md:text-2xl text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed font-[600]" data-id="element-110">
          El sistema práctico para que dejes de comer siempre lo mismo,
          organices tus comidas y prepares recetas ricas, variadas y 100%
          vegetales.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mb-10" data-id="element-111">
          <a href={SHOPIFY_URL} className="block" data-id="element-112">
            <motion.img src="https://cdn.magicpatterns.com/uploads/oTn1nHasg8aBPthxD1Y7Gu/Mockup_principal.png" alt="MEGAPACK DIETAS PARA VEGANOS - Mockup Principal" className="w-full max-w-lg mx-auto cursor-pointer bg-white" whileHover={{
            scale: 1.03
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} data-id="element-113" />
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl text-gray-600 font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-114">
          📚 Todo lo que necesitás en un solo lugar: recetas dulces y saladas,
          menús semanales, viandas, postres, sustituciones veganas, opciones
          económicas y mucho más.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8 mb-10 text-lg font-bold text-gray-800" data-id="element-115">
          <span className="flex items-center gap-2" data-id="element-116">
            <span className="text-green-500 text-2xl" data-id="element-117">✅</span> Sin pantallas
          </span>
          <span className="hidden sm:block text-gray-300" data-id="element-118">•</span>
          <span className="flex items-center gap-2" data-id="element-119">
            <span className="text-green-500 text-2xl" data-id="element-120">✅</span> Sin estrés
          </span>
          <span className="hidden sm:block text-gray-300" data-id="element-121">•</span>
          <span className="flex items-center gap-2" data-id="element-122">
            <span className="text-green-500 text-2xl" data-id="element-123">✅</span> Sin "tareas
            eternas"
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} data-id="element-124">
          <CTAButton subtext="✅ Garantía de satisfacción de 7 días" data-id="element-125" />
        </motion.div>
      </div>
    </section>;
}